import { useOutletContext } from "react-router-dom";

import HomePublisherView from "../views/HomePublisherView";

export default function HomePublisher() {
	const { organization } = useOutletContext();

	return <HomePublisherView organization={organization} />;
}
